module.exports = __webpack_public_path__ + "zvetseni-prsou_29_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/zvetseni-prsou_29_after.jpg
// module id = 1321
// module chunks = 0